import api from './api';

const controller = "parametro";

export interface Parametro {
  status: boolean;
  codigo: number;
  nome: string;
  observacao: string;
  parametroId: string;
}

export interface Historico {
  status: boolean;
  codigo: number;
  nome: string;
  observacao: string;
  parametroId: string;
  index: number;
  responsavel: string;
}

interface IGetAllParametros {
  codigo: number;
}



export const getAllParametros = (dados: IGetAllParametros) =>
  api.get<Parametro[]>(`${controller}?codigo=${dados.codigo}`);

export const getAllHistoricos = (dados: IGetAllParametros) =>
  api.get<Historico[]>(`${controller}/historico?codigoParametro=${dados.codigo}`);


export const getAllRelatorioExecucaoRotina = () =>
  api.get<Historico[]>(`${controller}/getAllRelatorioExecucaoRotina`);

export const updateParametro = (parametro: Parametro) => {
  return api
    .put<boolean>(`${controller}/updateParam/${parametro.parametroId}`, parametro)
    .then(result => true)
    .catch(err => false);
};


export const getAllHistoricoExecucaoRotinaContaResultadoFechamentoMina = () => {
  return api.get<Historico[]>('routinesCrfch/getAllHistoricoExecucaoRotinaContaResultadoFechamentoMina');
}


